import { createContext } from 'react';
import { ReemaThemeV2 } from '../reema-theme-V2';
import {
  CustomizationThemeDto,
  UserAppSettingsDto,
} from '@act/shared/data-transfer-objects';

export type ThemeKey = keyof typeof ReemaThemeV2;

export interface SettingsContextType {
  theme:
    | typeof ReemaThemeV2.LIGHT_MODE
    | typeof ReemaThemeV2.DARK_MODE
    | typeof ReemaThemeV2.COLOR_BLIND_MODE;
  themeKey: ThemeKey;
  setThemeKey: (themeKey: ThemeKey) => void;
  logoThemeId: number | null;
  accentThemeId: number | null;
  logoGradientColors: string[];
  accentGradientColors: string[];
  showAnimations: boolean;
  customizationThemes: CustomizationThemeDto[];
  isLoadingThemes: boolean;
  userAppSettings: UserAppSettingsDto | null;
  isLoadingUserSettings: boolean;
  updateUserAppSettings: (settings: {
    logoThemeId?: number | null;
    accentThemeId?: number | null;
    showAnimations?: boolean;
  }) => Promise<void>;
}

export const SettingsContext = createContext<SettingsContextType>({
  theme: ReemaThemeV2.LIGHT_MODE,
  themeKey: 'LIGHT_MODE',
  setThemeKey: () => {},
  logoThemeId: null,
  accentThemeId: null,
  logoGradientColors: [],
  accentGradientColors: [],
  showAnimations: false,
  customizationThemes: [],
  isLoadingThemes: true,
  userAppSettings: null,
  isLoadingUserSettings: true,
  updateUserAppSettings: async () => {},
});
